module.exports = __webpack_public_path__ + "img/app_logo.ede19a3d.png";